import { Tenant } from 'models/Tenant';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'

export const TenantActionType = {
    FETCH_TENANTS: 'FETCH_TENANTS',
    FETCH_TENANTS_SUCCESS: 'FETCH_TENANTS_SUCCESS',
    FETCH_CURRENTTENANT: 'FETCH_CURRENTTENANT',
    FETCH_CURRENTTENANT_SUCCESS: 'FETCH_CURRENTTENANT_SUCCESS',
    EDIT_CURRENTTENANT: 'EDIT_CURRENTTENANT',
    EDIT_CURRENTTENANT_SUCCESS: 'EDIT_CURRENTTENANT_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchTenantsAction {
    type: typeof TenantActionType.FETCH_TENANTS
    payload: ApiPayload,
    returnPayload: Tenant[],
    meta: {
        isApiCall: boolean
    },
}

interface ICurrentTenantAction {
    type: typeof TenantActionType.FETCH_CURRENTTENANT
    payload: ApiPayload,
    returnPayload: Tenant | null,
    meta: {
        isApiCall: boolean
    },
}

export type ITenantActions = IFetchTenantsAction | ICurrentTenantAction

export class TenantActions {
    public static fetchTenants(token: string): ITenantActions {
        return {
            type: TenantActionType.FETCH_TENANTS,
            payload: Api.fetchApiCall('api/tenants', token, TenantActionType.FETCH_TENANTS_SUCCESS, TenantActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static fetchCurrentTenant(token: string): ITenantActions {
        return {
            type: TenantActionType.FETCH_CURRENTTENANT,
            payload: Api.fetchApiCall('api/tenants/current', token, TenantActionType.FETCH_CURRENTTENANT_SUCCESS, TenantActionType.API_ERROR),
            returnPayload: null,
            meta: {
                isApiCall: true
            },
        }
    }

    public static editCurrentTenant(token: string, tenant: Tenant): ITenantActions {
        return {
            type: TenantActionType.EDIT_CURRENTTENANT,
            payload: Api.putApiCall('api/tenants/current', token, TenantActionType.EDIT_CURRENTTENANT_SUCCESS, TenantActionType.API_ERROR, tenant, true),
            returnPayload: null,
            meta: {
                isApiCall: true
            },
        }
    }
}
